import drawText from './drawText'
import { scaleLinear } from 'd3-scale'

const opacityScale = scaleLinear().range([0.6, 0]).clamp(true)

const textTrimScale = scaleLinear().range([10, 30]).clamp(true)

const Area = ({
  area: a,
  dx,
  dy,
  minScale,
  maxScale,
  xScale,
  yScale,
  fontSize,
  context,
  transform: t,
  filtered,
  pixelsPerFoot,
  highlighted,
  selected,
}) => {
  opacityScale.domain([minScale, pixelsPerFoot ? 0.8 * maxScale : maxScale / 3])
  textTrimScale.domain([minScale, maxScale / 2])

  const opacity = opacityScale(t.k)
  let minX = Infinity
  let maxX = -Infinity
  let minY = Infinity
  let maxY = -Infinity

  a.forEach(([x, y], i) => {
    const _x = dx * t.k + xScale(x)
    const _y = dy * t.k + yScale(y)

    if (minX > _x) minX = _x
    if (maxX < _x) maxX = _x
    if (minY > _y) minY = _y
    if (maxY < _y) maxY = _y

    if (i === 0) {
      context.beginPath()
      context.moveTo(_x, _y)
    } else if (i === a.length - 1) {
      context.lineTo(_x, _y)
      context.closePath()
    } else {
      context.lineTo(_x, _y)
    }
  })

  if (opacity > 0 && !filtered) {
    context.fillStyle = `#${a.color}`
    context.globalAlpha = opacity
    context.fill()
  }

  context.strokeStyle = `#${a.color}`
  context.lineWidth = 2
  context.globalAlpha = 0.6

  if (highlighted || selected) {
    context.strokeStyle = selected ? '#1B4BC5' : 'dodgerblue'
    context.lineWidth = 3
    context.globalAlpha = 1
  }

  context.stroke()

  let text = a.name
  if (text.length > textTrimScale(t.k)) {
    text = `${text.substr(0, textTrimScale(t.k))}…`
  }

  if (opacity > 0 && t.k >= 1 && !filtered) {
    context.globalAlpha = 1

    drawText({
      context,
      x: dx * t.k + xScale(a.center.x),
      y: dy * t.k + yScale(a.center.y),
      text,
      fontSize: 1.2 * fontSize,
      fillStyle: '#333',
      textBaseline: 'bottom',
      shadow: true,
      center: true,
    })
  }

  a.viewRect = {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY,
  }
}

export default Area
